/**
 * Which module a row came from. Matches AttentionSourceType on the server.
 */
export enum AttentionSourceType {
    GroupInvite = 1,
    NewsAcknowledgement = 2,
    LearningCourse = 3,

    /**
     * A form answer somebody has to deal with. Belongs to the people the answers
     * go to, not to whoever filled the form in.
     */
    FormResponse = 4,
}

/**
 * What a row belongs to. Always a person for now; the field exists so that rows
 * owned by a place can arrive later without this contract changing.
 */
export enum AttentionSubjectType {
    Person = 1,
}

export interface IAttentionRow {
    sourceType: AttentionSourceType;
    sourceItemId: number;
    subjectType: AttentionSubjectType;
    subjectId: number;
    title: string;
    url: string;
    dueAt: string | null;
    isMandatory: boolean;
    isOverdue: boolean;
}

export interface IAttentionList {
    /**
     * False when the surface is off for this instance, the person is outside the
     * pilot, or they are signed in on a shared location account. Show nothing
     * rather than an empty list, which would read as "you are done".
     */
    applicable: boolean;
    rows: IAttentionRow[];
    count: number;

    /**
     * Sources that could not be read on this request. A list with any of these is
     * incomplete and should say so rather than imply there is nothing left.
     */
    unavailableSources: AttentionSourceType[];
    introDismissed: boolean;
}

export interface IAttentionCount {
    applicable: boolean;
    count: number;
    unavailableSources: AttentionSourceType[];
}

/**
 * Sent when something in a person's list may have changed. Carries no rows; the
 * client asks again when it is ready to.
 */
export const attentionChangedEventName = "Attention:Changed";

export interface IAttentionChangedMessage {
    /**
     * "user" reached one or two named people who just did something. "instance"
     * reached everyone connected, and they must not all refetch at once.
     */
    scope: "user" | "instance";
}

/**
 * The three states every app notification setting has. Matches
 * AppNotificationSetting on the server.
 */
export enum AppNotificationSetting {
    Off = 0,
    On = 1,
    DuringWorkHours = 2,
}
